<main>
  @if (errorState(); as error) {
    <app-inline-error-status [error]="error"></app-inline-error-status>
  } @else {
    <router-outlet></router-outlet>
  }
</main>
